import React from 'react';

import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '400px'
};

const center = {
  lat: 43.67850554386909,
  lng: -79.72748241252299
};

const Map = () => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyDzRq14jMORnMXGuYwNDCsfxnBoFrjB8Rg"
  })
  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  return isLoaded ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
         <Marker
      // icon={"https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png"}
      position={center}
    />
        { /* Child components, such as markers, info windows, etc. */ }
        <div id="google-map-script"></div>
      </GoogleMap>
  ) : <></>
}

export default React.memo(Map)